import styled from "styled-components";

import * as Sticker from "ds/Sticker";

export const ErrorMessageWrapper = styled(Sticker.Root)`
  padding: 10px 16px;
  display: flex;
  align-items: center;
  margin: 32px 0;
  font-weight: 600;
  font-size: 13px;
  line-height: 20px;

  pre {
    line-height: 21px;
    font-size: 12px;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    white-space: pre;
    margin-right: 0;
    margin-bottom: 20px;
    padding: 15px;
    border-radius: 4px;
    text-align: left;
  }
`;
